export const onClientEntry = async () => {
  // polyfill intersetion observer
  if (typeof window.IntersectionObserver === 'undefined') {
    await import('intersection-observer');
  }
};
